export default __webpack_public_path__ + "static/chuckling-1e093dce28214364eec984ac029b5a9a.svg";